import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { testHistoryStateStyles } from './styles';

export default function TestHistoryEmptyState({ totalResults }) {
  const isFiltered = totalResults && totalResults > 0;

  return (
    <Box sx={testHistoryStateStyles.emptyContainer}>
      <SearchOffIcon sx={testHistoryStateStyles.emptyIcon} />
      <Typography variant="h6" gutterBottom>
        {isFiltered ? 'No results match your filters' : 'No test results found'}
      </Typography>
      <Typography variant="body2">
        {isFiltered
          ? 'Try adjusting your filter selections to see more results.'
          : 'Try adjusting your search filters or check if the regression test ID is correct.'}
      </Typography>
    </Box>
  );
}
